var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.369,
    height: 17.613,
    rx: 3.5,
    fill: "#fff",
    stroke: "#E3EAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.337 12.299H6.74L5.542 7.594c-.057-.216-.178-.407-.355-.498a5.097 5.097 0 00-1.464-.498v-.18h2.573c.355 0 .621.271.666.587l.621 3.394L9.18 6.417h1.553L8.337 12.3zm3.285 0h-1.509l1.242-5.882h1.51l-1.243 5.881zm3.194-4.252c.044-.317.31-.498.621-.498a2.741 2.741 0 011.464.271l.267-1.266a3.723 3.723 0 00-1.376-.272c-1.464 0-2.53.814-2.53 1.945 0 .86.755 1.312 1.288 1.584.576.271.798.452.754.723 0 .407-.444.588-.887.588a3.714 3.714 0 01-1.553-.362l-.266 1.267c.532.226 1.109.317 1.641.317 1.642.045 2.662-.77 2.662-1.99 0-1.539-2.085-1.63-2.085-2.307zm7.364 4.252l-1.198-5.882h-1.287a.669.669 0 00-.621.453l-2.219 5.429h1.553l.31-.86h1.909l.177.86h1.376zM19.916 8l.443 2.216h-1.242l.8-2.216z",
    fill: "#28356A"
  })));
}
export default __webpack_public_path__ + "static/media/Visa.45ceafba.svg";
export { SvgVisa as ReactComponent };